import type { InstancesSlice, InstancesState, ViewerSliceCreator } from "./types";

export const instancesInitialState: InstancesState = {
  instances: [],
};

export const createInstancesSlice: ViewerSliceCreator<InstancesSlice> = (set) => ({
  ...instancesInitialState,

  setInstanceList: (msg) =>
    set((state) => {
      state.instances = msg.instances;
    }),
});
